module.exports = __webpack_public_path__ + "img/news8-5.1e02f034.png";